import Vue from 'vue';
import Vuex from 'vuex';
import {mallRequest} from '../components/utils/ticket.js';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    currentMenu:null,
    tabsList: [
      {
        name: 'home',
        label: '首页',
      }
    ],
    headerCoverData:{
      
    },
    account:{

    }
  },
  getters: {

  },
  mutations: {
    //选择标签
    selectMenu(state, val) {
      if (val.name === 'home') {
        state.currentMenu = null
      } else {
        state.currentMenu = val
        //如果等于-1说明tabsList不存在那么插入，否则什么都不做
        let result = state.tabsList.findIndex(item => item.name === val.name)
        result === -1 ? state.tabsList.push(val) : ''
      }
    },
    //关闭标签
    closeTab(state, val) {
      let result = state.tabsList.findIndex(item => item.name === val.name)
      state.tabsList.splice(result, 1)
    },
  },
  actions: {
    zhanghu(store,callback){
      mallRequest({
        apiName: 'account',
        method: 'get',
        data: {},
      }).then(res => {
        console.log(res)
        if (res && res.code==200) {
          store.state.account=res.data;
          localStorage.setItem('FXaccount',JSON.stringify(res.data));
          if(callback){
            callback()
          }
        }
      }).catch(e => {
        console.log(e);
      })
    }
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js